import BASE_RULE from '../baseRule';
import {SearchTypeFileFormat, FileFormatType} from './constants';
import {FileFormatRule} from './types';

export const fileFormatRuleDefaults: FileFormatRule = {
	...BASE_RULE,
	elementType: SearchTypeFileFormat,
	elementSubType1: FileFormatType.ONLY,
	elementValue1: '',
};

export default fileFormatRuleDefaults;
